'use strict';

$('.reset-filter-btn').click(() => {
    $('.reset-hidden-btn').trigger('click')
})
